


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
var body = document.body;
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});




const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        // detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        // parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    const fulloverlay = document.querySelector(".full-overlay");
    fulloverlay.classList.add("full-overlay-active")
      
  }
  
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      
      if (modal) modal.show(button);
      
  
    });
  }
}
customElements.define('modal-opener', ModalOpener);

document.querySelector(".full-overlay").addEventListener("click", function () {
  const fulloverlayclose = document.querySelector(".full-overlay");
  fulloverlayclose.classList.remove("full-overlay-active")
  document.querySelector(".quick-add-modal[open] .quick-add-modal__toggle").click();
})

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    if(document.body.classList.contains('template-product')){
      if(e.target.getAttribute('name') == 'Size' || e.target.getAttribute('name') == 'size'){
        var sizes = this.querySelectorAll('.size-wrapper input')
        sizes.forEach(item => {
          item.classList.remove('active')
        })
        e.target.classList.add('active')
        this.classList.add('active')
        document.querySelector('.size-option').style.color = ""
        document.querySelector('.size-option').innerHTML = "SIZE"
      }
    }
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia(e);
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
    
  }

  updateMedia(e) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    if(body.classList.contains("page-create-my-set")){
      var colorvalue = e.target.getAttribute("data-filter2")
      var vectorval = e.target.getAttribute("data-filter")
      var appendVector = "vector-"+ vectorval;
      var getparentEle  = e.target.parentElement;
      var colornamediv = getparentEle.querySelector(".selected-color-name")
      colornamediv.innerHTML = colorvalue
      var varclickid = this.currentVariant.featured_image.product_id;
      var varImage = this.currentVariant.featured_media;
      var imageSource = varImage.preview_image.src;
      document.querySelectorAll(".swiper-slide-active").forEach(activeproduct=>{
        var activeslide = Number(activeproduct.getAttribute("data-product-id"));
        if(varclickid === activeslide ){ 
          var imageElement = activeproduct.querySelectorAll("img");
          if(imageElement){
            imageElement.forEach(allactiveimages=>{
             var getAlt = allactiveimages.getAttribute("alt");
                if(getAlt == appendVector){
                   allactiveimages.style.display = "block"
                }else{
                   allactiveimages.style.display = "none"
                }
            })
          }
          
        }
    })
    }
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
      

  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    if(body.classList.contains("template-page")){
       console.log("page template")
    }else{
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }); 
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    console.log(requestedVariantId)
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        //price change for create set page
        if(body.classList.contains("page-create-my-set")){
          var variantPrice = source.querySelector(".main-price").innerText.trim();
          document.querySelectorAll(".swiper-slide-active").forEach(activeslide=>{
            var activeswiperslide  = Number(activeslide.getAttribute("data-product-id"));
            var activeProid = Number(source.getAttribute("data-id"));
            document.querySelectorAll(".product-price").forEach(proinfo=>{
              var allproid = Number(proinfo.getAttribute("data-id"));
              if(allproid === activeProid){
                if (source && proinfo) proinfo.innerHTML = source.innerHTML;
              }
          })
            if(activeswiperslide === activeProid){
              
              activeslide.setAttribute("var-data-price", variantPrice)
              var varsetoneprice  = document.querySelector(".setoneslide.swiper-slide-active").getAttribute("var-data-price");
              var varsettwoprice  = document.querySelector(".settwoslide.swiper-slide-active").getAttribute("var-data-price");
              var varsetonepriceNumber = parseFloat(varsetoneprice.replace('$', ''));
              var varsettwopriceNumber = parseFloat(varsettwoprice.replace('$', ''));
              var vartotalprice = varsetonepriceNumber + varsettwopriceNumber;
              var varformattedTotalPrice = '$' + vartotalprice.toFixed(2);
              document.querySelector(".total-set-price").innerText = varformattedTotalPrice;

            }
          })
        }else{
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
        //end price change code for create set page
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

            // const price = document.getElementById(`price-${this.dataset.section}`);
            //  if(!body.classList.contains("page-create-my-set")){
            //      const salePercentage = price.querySelector(".sale-percentage");
            //       if(salePercentage){
            //         const salePercentagetext = salePercentage.innerHTML;
            //         document.querySelector(".product-badge-sale").innerText = salePercentagetext;
            //         document.querySelector(".product-badge-sale").classList.remove("hide")
            //       }else if ( salePercentage == null){
            //         document.querySelector(".product-badge-sale").classList.add("hide")
            //       }
            //  }

        const price = document.getElementById(`price-${this.dataset.section}`);
if (!body.classList.contains("page-create-my-set")) {
    const salePercentage = price.querySelector(".sale-percentage");

    // Get the product badge sale element
    const productBadgeSale = document.querySelector(".product-badge-sale");

    if (salePercentage) {
        const salePercentagetext = salePercentage.innerHTML;

        // Check if the sale percentage is '0%'
        if (salePercentagetext.trim() === '-0%') {
            productBadgeSale.classList.add("hide"); // Hide badge if sale percentage is 0%
        } else {
            productBadgeSale.innerText = salePercentagetext; // Set the sale percentage text
            productBadgeSale.classList.remove("hide"); // Show the badge
        }
    } else {
        productBadgeSale.classList.add("hide"); // Hide badge if there's no sale percentage element
    }
}

        

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  
 
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          colorswatches()
          sizeAddTocart();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



// collection cstm sale badge start

function colorswatches() {
    var mycolor = document.querySelectorAll('.item-image-wrapper:not(.single-swatch)');
    mycolor.forEach(items => {
        var sizeSwatch2 = items.closest('.card-wrapper').querySelectorAll('.quick-cart-add ul li');
        var par = items.closest('.card-wrapper');
        items.addEventListener("click", (e) => {
            var variantUrl = items.getAttribute('url');
            var quickviewUrl = items.getAttribute('data-url');
            var varPrice = items.getAttribute('varprice');
            var varComparePrice = items.getAttribute('varcompareprice');
            var varPriceWithoutdecimal = items.getAttribute('data-variant-price');
            var varComparePriceWithoutdecimal = items.getAttribute('data-variant-compare-price');
            var variantColor = items.getAttribute('data-val-2');
            var variantColorwithoutdash = items.getAttribute('data-value');
            var variantImageId = items.getAttribute('data-img-id');
            var variantImg = items.getAttribute('data-img');
            var otherColors = items.closest('.item-swatch').querySelectorAll('.item-image-wrapper');
            var ColorsName = par.querySelector(".color-name");
            var pricediv = par.querySelector(".price__container");
            var percentageContainer = par.querySelector(".sale-percentage");
            var percentageMainDiv = par.querySelector(".sale-percentage-badge");
            pricediv.innerHTML = '';
            const regularPriceSpan = document.createElement('span');
            regularPriceSpan.classList.add('cstm-regular-price');
            regularPriceSpan.innerText = varPrice;

            if (varComparePrice && varPrice !== 'null') {
                const comparePriceSpan = document.createElement('span');
                comparePriceSpan.classList.add('cstm-compare-price');
                comparePriceSpan.classList.add('cstm-sale-price');
                regularPriceSpan.classList.add('cstm-sale-regular-price');

                // Check if the prices are the same
                if (varPriceWithoutdecimal !== varComparePriceWithoutdecimal) {
                    comparePriceSpan.innerText = varComparePrice;
                    pricediv.appendChild(comparePriceSpan);
                }

                pricediv.appendChild(regularPriceSpan);

                var salePercentage = Math.floor(((varComparePriceWithoutdecimal - varPriceWithoutdecimal) * 100) / varComparePriceWithoutdecimal);
                if (percentageContainer) {
                    if (salePercentage > 0) {
                        percentageContainer.innerText = "-" + salePercentage + "%";
                        percentageMainDiv.classList.remove("hide");
                    } else {
                        percentageContainer.innerText = ''; // Clear the text
                        percentageMainDiv.classList.add("hide"); // Hide the percentage if salePercentage is 0
                    }
                }
            } else {
                pricediv.appendChild(regularPriceSpan);
                if (percentageMainDiv) {
                    percentageMainDiv.classList.add("hide");
                }
            }

            ColorsName.innerHTML = variantColor;

            otherColors.forEach(v => {
                v.classList.remove('active');
            });
            items.classList.add('active');
            items.closest('.card-wrapper').querySelector('.image-first').setAttribute('srcset', variantImg);
            items.closest('.card-wrapper').querySelector('.image-first').setAttribute('src', variantImg);

            var filter = `.id-${variantImageId}`;
            console.log(filter, "filter");
            var secondImage = items.closest('.item-swatch').querySelector(filter).nextElementSibling.getAttribute('data-image');
            items.closest('.card-wrapper').querySelector('.image-second').setAttribute('srcset', secondImage);
            items.closest('.card-wrapper').querySelector('.image-second').setAttribute('src', secondImage);
            items.closest('.card-wrapper').querySelector('.image-second').setAttribute('src', secondImage);
            var sizeSwatch = items.closest('.card-wrapper').querySelectorAll('.quick-cart-add ul li');
            sizeSwatch.forEach(a => {
                a.classList.add('hide-variant');
                var sizeDataVal = a.getAttribute('data-show');
                if (sizeDataVal == variantColorwithoutdash) {
                    a.classList.remove('hide-variant');
                }
            });
            items.closest('.card-wrapper').querySelector('.quick-add__submit').setAttribute('data-product-url', quickviewUrl);
            var activeColor = document.querySelectorAll('.item-image-wrapper.active:not(.single-swatch)');
            activeColor.forEach(a => {
                var activeUrl = a.getAttribute('url');
                a.closest('.card-wrapper').querySelectorAll('.product-link').forEach(b => {
                    b.setAttribute('href', activeUrl);
                });
            });
        });
    });
}


// collection cstm sale badge end





colorswatches();

function sizeAddTocart(){
  var btn1 = document.querySelectorAll('.quick-cart-add ul li:not(.sold_out)')
  btn1.forEach(item1 => {
    item1.addEventListener('click', ()=> {
         var variantId1 = item1.getAttribute('data-id')
         
        item1.closest('.card-wrapper').classList.add('size-selected')
        item1.closest('.card-wrapper').setAttribute('data-variant-id', variantId1)
        
             var formData = {
             'items': [{
            'id': variantId1,
              'quantity': 1
              }]
             }
            fetch('/cart/add.js', { 
               method: 'POST',
               headers: {
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify(formData) 
             })
             .then(response => {
               return response.json()
             })
            .then((data)=>{
               if (data.status === 422){
                 body.classList.add('cart-error-active')
                 document.querySelector('#cart-error-popup').innerText = data.description
                 setTimeout(()=> {
                     body.classList.remove('cart-error-active')
                },3000)
               }
               else{
                   var spinner = item1.querySelector('.loading-overlay__spinner')
                   console.log(spinner)
                   if(spinner){
                     spinner.classList.remove('hidden')
                   }
                   cartPopupUpdate()
                   setTimeout(()=> {
                    body.classList.add('cart-popup-active')
                    body.classList.add('dropdown-shadow')
                     if(spinner){
                      spinner.classList.add('hidden')
                     }
                  },500)
              }
             })
          .catch((error) => {
                body.classList.add('cart-error-active')
                document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
                setTimeout(()=> {
                    body.classList.remove('cart-error-active')
                },3000)
            })
           .finally(() => {
            })
    });
  });
  }
  sizeAddTocart();
function cartPopupUpdate(){
    // for updating cart popup
    fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
    })
    .then(response => {
        return response.json()
    })
    .then((cart)=>{        
        var lineItems = []
        document.querySelector('.mini-products-list').innerHTML = ''
        var cartCounter = cart.item_count
        document.querySelector('.cart-counter').innerText = cartCounter
        var totalPrice = priceFormatting(cart.total_price / 100)
        cart.items.forEach((item, i) => {
            var itemPrice = priceFormatting(item.price / 100)
            var lineItemDetails = `<li class="item" data-id="${item.id}" data-line="${i+1}">
                <a href="${item.url}" class="product-image">
                <img loading="lazy" src="${item.image}" alt="${item.title}">
                </a>
                <div class="product-details">
                <a href="javascript:void(0)" title="Remove" class="btn-remove">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                        <path d="M15.1667 3.5H1" stroke="#FF7262" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M13.7756 5.58325L13.3923 11.3325C13.2448 13.5449 13.1711 14.6512 12.4502 15.3255C11.7294 15.9999 10.6207 15.9999 8.40339 15.9999H7.75897C5.54159 15.9999 4.43293 15.9999 3.71209 15.3255C2.99125 14.6512 2.9175 13.5449 2.77 11.3325L2.38672 5.58325" stroke="#FF7262" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M6 7.66675L6.41667 11.8334" stroke="#FF7262" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M10.1667 7.66675L9.75 11.8334" stroke="#FF7262" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M3.5 3.5C3.54657 3.5 3.56985 3.5 3.59096 3.49947C4.27716 3.48208 4.88252 3.04576 5.11602 2.40027C5.1232 2.38041 5.13056 2.35833 5.14528 2.31414L5.22619 2.07142C5.29526 1.86423 5.32979 1.76063 5.37559 1.67267C5.55834 1.32172 5.89645 1.07803 6.28717 1.01564C6.38511 1 6.49433 1 6.71275 1H9.45392C9.67233 1 9.78158 1 9.8795 1.01564C10.2702 1.07803 10.6083 1.32172 10.7911 1.67267C10.8369 1.76063 10.8714 1.86423 10.9405 2.07142L11.0214 2.31414C11.0361 2.35827 11.0435 2.38042 11.0507 2.40027C11.2842 3.04576 11.8895 3.48208 12.5757 3.49947C12.5968 3.5 12.6201 3.5 12.6667 3.5" stroke="#FF7262" stroke-width="1.5"></path>
                   </svg>
                </a>
                <a class="product-name" href="${item.url}">${item.product_title}</a>
                <div class="option">
                <small>${item.variant_title}</small>
                </div>
                <div class="cart-quantity">${item.quantity}X</div>
                <div class="cart-collateral">
                    <span class="price">
                    <span class="money">PKR ${itemPrice}</span>
                    </span>
                </div>
                </div>
            </li>`
            lineItems.push(lineItemDetails) 
        })
        document.querySelector('.mini-products-list').innerHTML = lineItems.join('')
        document.querySelector('.total .price').innerText = `PKR ${totalPrice}`
        if(cartCounter > 0){
            document.querySelector('.cart-count-bubble').classList.remove('hidden')
            document.querySelector('#dropdown-cart .has-items').classList.remove('hidden')
            document.querySelector('#dropdown-cart .no-items').classList.add('hidden')
        }else{
            
            document.querySelector('#dropdown-cart .has-items').classList.add('hidden')
            document.querySelector('#dropdown-cart .no-items').classList.remove('hidden')
        }

    })
    .catch((error) => {
        body.classList.add('cart-error-active')
            document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
            setTimeout(()=> {
                body.classList.remove('cart-error-active')
        },3000)
    })
    .finally(() => {
        removeCartItem()
    })
}

function priceFormatting(price){
   
    var formatPrice = new Intl.NumberFormat('en-PK', { maximumSignificantDigits: 3 }).format(price)
    return formatPrice
}

function removeCartItem(){
    // Remove from cart
    var btn = document.querySelectorAll('.btn-remove')
    btn.forEach(item => {
      item.addEventListener('click', (e)=> {
        e.preventDefault()
        var lineId = item.closest('.item').getAttribute('data-line')
        var formData = {
            'line': lineId,
            'quantity': 0
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json()
        })
        .then((data)=>{
          if (data.status === 422){
          }
          else{
            cartPopupUpdate()
          }
        })
        .catch((error) => {
            body.classList.add('cart-error-active')
            document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
            setTimeout(()=> {
                body.classList.remove('cart-error-active')
            },3000)
        })
      })
    })
}
removeCartItem()

function close(){
  if(body.classList.contains('cart-popup-active')){
      body.classList.remove('cart-popup-active')
  }

  body.classList.remove('dropdown-shadow')
}

document.querySelector('#dropdown-shadow').addEventListener('click', (e)=> {
  e.preventDefault()
  close()
})

if(!body.classList.contains("template-cart")){  
  document.querySelector(".header__icon--cart").addEventListener("click", function(){
      body.classList.add('cart-popup-active')
      body.classList.add('dropdown-shadow') 
  })
}
document.querySelector(".close-cart.close").addEventListener("click", function(){
      close() 
  })


if(body.classList.contains('template-collection') || body.classList.contains('template-search')){
    function infinite(){
      const mainGrid = document.querySelector('#product-grid');
      const infiniteScrollElement = document.querySelector('.infinite__scroll--button-wrap')
      let isLoading = false;
        if (infiniteScrollElement && mainGrid) {
              const Ajaxbutton = infiniteScrollElement.querySelector("#ajaxcall");
              let nextPageURL = Ajaxbutton.getAttribute('href');
              let Loading_More = infiniteScrollElement.querySelector('#loadmore');
              console.log(Loading_More,"Loading_More")
              const loadMoreContent = () => {
                if (isLoading || !nextPageURL) return; 
            
                  isLoading = true; 
                fetch(nextPageURL)
                .then((response) => {
                  if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                  }
                  return response.text();
                })
                .then((text) => {
                  let parsedHTML = new DOMParser().parseFromString(text, 'text/html');
                  let productGrid = parsedHTML.querySelector('#product-grid');
                  let nextUrl = parsedHTML.querySelector('#ajaxcall');
                  console.log(parsedHTML)
                  if (!nextUrl) {
                    Loading_More.innerText = "No More Products";
                    document.querySelector(".no-more-cstm").classList.remove("hide-backto-top")
                    nextPageURL = null;
                  } else {
                    nextPageURL = nextUrl.href;
                    console.log(nextPageURL)
                    document.querySelector(".no-more-cstm").classList.add("hide-backto-top")
                  }      
                  if (productGrid) {
                    mainGrid.insertAdjacentHTML('beforeend', productGrid.innerHTML);
                  }
                  isLoading = false;
                  sizeAddTocart();
                  colorswatches();
                  backtoTop();
                  sortopenclose();
                  gridchanger()
                })
                .catch(error => {
                  console.error("Error fetching data:", error);
                  isLoading = false;
                });
              }
              window.addEventListener('scroll', function () {
              const mainGridRect = mainGrid.getBoundingClientRect();
              const scrollHeight = document.documentElement.scrollHeight;
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const windowHeight = window.innerHeight || document.documentElement.clientHeight;
              const triggerOffset = mainGridRect.height / 2;
              if (scrollTop + windowHeight >= mainGridRect.top + triggerOffset) {
                loadMoreContent();
              }
            });
         }
  }   
  infinite()

      //this is the code for back to top functionlaity
       function backtoTop(){
            document.querySelectorAll(".no-more-cstm").forEach(backtotop=>{
                backtotop.addEventListener("click", function(){ 
                    window.scrollTo({
                      top:0,
                      behavior:"smooth"
                    })
                })
            })
      }
      backtoTop()


      function sortopenclose(){
        document.querySelector(".sort-label").addEventListener("click", function(){
          var sorting = document.querySelector(".sorting-select-option");
          var caretSvg = document.querySelector(".sort-label .caret-icon");
          if(sorting.classList.contains("active")){
              sorting.classList.remove("active")
              caretSvg.classList.remove("active")
          }
          else{
              sorting.classList.add("active")
              caretSvg.classList.add("active")
          }
      })
      }sortopenclose()


    //this is the code for grid changer
            
        function gridchanger(){
          var gridItems = document.querySelectorAll('.grid-item-list');
          //gridswitcher
          document.querySelectorAll('.grid-2').forEach(grid2 => {
            grid2.addEventListener('click', () => {
                gridTwoActive();
                setCookie('activeGrid', "grid-2", 365)
            });
        });
        document.querySelectorAll('.grid-4').forEach(grid4 => {
          grid4.addEventListener('click', () => {
            gridFourActive()
            setCookie('activeGrid', "grid-4", 365)
          });
        });

        function gridTwoActive(){
        document.querySelector('.grid-4').classList.remove('activegrid')
        document.querySelector('.grid-2').classList.add('activegrid')
        document.querySelector('.mb-grid-1 svg rect').classList.add('activegrid')
        document.querySelectorAll('.mb-grid-2 svg path').forEach(element => {
          element.classList.add('removegrid');
        });
        gridItems.forEach(gridItem => {
          gridItem.classList.add('grid-2-active');
        });
        }
        function gridFourActive(){
        document.querySelector('.grid-4').classList.add('activegrid')
        document.querySelector('.grid-2').classList.remove('activegrid')
        document.querySelector('.mb-grid-1 svg rect').classList.remove('activegrid')
        document.querySelectorAll('.mb-grid-2 svg path').forEach(element => {
          element.classList.remove('removegrid');
        });
        gridItems.forEach(gridItem => {
          gridItem.classList.remove('grid-2-active');
        });
        }

        var activegrid = getCookie('activeGrid'); 
        if(activegrid == "grid-2"){
          gridTwoActive()
        }
        else if(activegrid == "grid-4"){
          gridFourActive()
        }

        }
        gridchanger()
}














